import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import Dados from './Dados'
import Itens from './Itens'
import RevisaoAvaliacao from './RevisaoAvaliacao'
import { Route, Switch, Redirect } from 'react-router-dom'
import ProgressTracker from '../../containers/ProgressTracker'
import NavBreadCrumb from '../../containers/NavBreadCrumb'
import { API_HOST } from '../../consts'
import axios from 'axios'

class Avaliacao extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isDisabled: false
    }
  }

  label = 'Atividades cognitivas';
  link = '/instrumentos-cognitivos';
  url = window.location.href;
  parts = this.url.split('/');
  tipoId = this.parts.pop();

  componentDidMount() {
    this.fetchAvaliacao()
  }

  get steps() {
    const {
      match,
      location: { pathname }
    } = this.props

    const { me } = this.state

    const groups = me && me.logged_group.map(f => { return f.toUpperCase(); })

    const stepArray = [
      {
        id: 1,
        title: `Informações sobre a ${this.breadCrumb3}`,
        link: `${this.link}/${match.params.id}/dados`,
        path: `${this.link}/:id/dados`,
        active: pathname === `${this.link}/${match.params.id}/dados`,
        done: match.params.id !== 'new',
        disabled: false,
        component: () => <Dados isDisabled={this.state.isDisabled} />,

      },
      {
        id: 2,
        title: 'Adicionar Objetos de Aprendizagem',
        link: `${this.link}/${match.params.id}/itens`,
        path: `${this.link}/:id/itens`,
        active: pathname === `${this.link}/${match.params.id}/itens`,
        done: false,
        disabled: match.params.id === 'new',
        // component: Itens
        component: () => <Itens isDisabled={this.state.isDisabled} hasPermission={this.props.hasPermission('avaliacoes.view_avaliacaoitemcomentario')} hasPermissionAll={this.props.hasPermission('__all__')} />,
      },
    ]

    groups && groups.includes("REVISOR") && stepArray.push({
      id: 3,
      title: 'Revisão da avaliação',
      link: `${this.link}/${match.params.id}/revisao`,
      path: `${this.link}/:id/revisao`,
      active: pathname === `${this.link}/${match.params.id}/revisao`,
      done: false,
      disabled: false,
      // component: revisao
      component: () => <RevisaoAvaliacao isDisabled={this.state.isDisabled} />,
    })

    return stepArray
  }



  fetchMe(item) {
    const token = localStorage.getItem('token')
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        let groups = response.data.logged_group.map(f => { return f.toUpperCase(); })
        this.setState({
          isDisabled: (groups.includes('ADMINISTRADOR') || groups.includes('DRE')) ? false : item && response.data.id == item.criado_por_id ? false : true,
          me: response.data
        })
      })
      .catch((response) => console.log(response.error))
  }

  fetchAvaliacao() {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${this.props.match.params.id}`)
      .then((response) => {
        this.fetchMe(response.data)
      })
      .catch(() => {
        // this.fetchMe()
      })

  }



  render() {
    const { match } = this.props
    switch (this.tipoId) {
      case '1':
        this.breadCrumb = match.params.id === 'new' ? 'Nova Trilha Adaptativa' : 'Trilha Adaptativa';
        this.breadCrumb2 = 'Trilhas adaptativas';
        this.breadCrumb3 = 'Trilha adaptativa';
        break;
      case '2':
        this.breadCrumb = match.params.id === 'new' ? 'Nova Avaliação' : 'Avaliação';
        this.breadCrumb2 = 'Avaliações';
        this.breadCrumb3 = 'Avaliação';
        break;
      case '3':
        this.breadCrumb = match.params.id === 'new' ? 'Nova Atividade Processual' : 'Atividade Processual';
        this.breadCrumb2 = 'Atividades Processuais';
        this.breadCrumb3 = 'Atividade processual';
        break;
      default:
        this.breadCrumb = 'Nova Avaliação';
        this.breadCrumb2 = 'Avaliações';
        this.breadCrumb3 = 'Avaliação';
        break;
    }
    const pathList = [
      {
        label: this.breadCrumb2,
        icon: 'list',
        link: '/instrumentos-cognitivos/tipo/' + this.tipoId
      }
    ]
    const currentPath =
      match.params.id === 'new'
        ? this.breadCrumb
        : `Avaliação ${match.params.id}`
    return (
      <div>
        <NavBreadCrumb pathList={pathList} currentPath={this.breadCrumb} />
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <ProgressTracker steps={this.steps} />
            </div>
            <div className="col-sm-9">
              <Switch>
                {this.steps.map((step, index) => (
                  <Route
                    key={step.id}
                    path={step.path}
                    render={() =>
                      step.disabled ? (
                        <Redirect to="/instrumentos-cognitivos/new/dados" />
                      ) : (
                        <step.component step={index} />
                      )
                    }
                  />
                ))}
                <Route
                  path="/instrumentos-cognitivos/:id"
                  render={() => (
                    <Redirect
                      to={`/instrumentos-cognitivos/${match.params.id}/dados`}
                    />
                  )}
                />
                <Redirect to="/instrumentos-cognitivos" />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Avaliacao)
